import { enums } from "superstruct"

export enum Pages {
    CARDS = "CARDS",
    SESSION_DATE = "SESSION_DATE",
    FORM = "FORM",
    PAYMENT = "PAYMENT",
    SUCCESS = "SUCCESS",
}

export const PagesEnums = enums([
    Pages.CARDS,
    Pages.SESSION_DATE,
    Pages.FORM,
    Pages.PAYMENT,
    Pages.SUCCESS,
])
